export enum Files {
    USSupplierInformationFormTitle = "US Supplier Vendor Form",
	USSupplierInformationFormPath = "/documents/US Supplier Information Form.pdf",
    ForeignSupplierInformationFormTitle = "Foreign Supplier Vendor Form",
    ForeignSupplierInformationFormPath = "/documents/Foreign Supplier Information Form.pdf",
}